export function canEditMealDate(mealDate: string, now = new Date()): boolean {
  const cutoff = new Date(`${mealDate}T01:30:00.000Z`);
  return now.getTime() < cutoff.getTime();
}

export function isMealDateFinalized(mealDate: string, now = new Date()): boolean {
  return !canEditMealDate(mealDate, now);
}
